export const CHOOSE_DATA_SOURCE_MODAL_I18N_PREFIX = "features.topics.components.choose_data_source_modal";

export const CHOOSE_DATA_SOURCE_MODAL_I18N_KEYS = {
  getting_started_title:                      "getting_started_title",
  getting_started_prompt:                     "getting_started_prompt",
  keyword_filtering_button_text:              "keyword_filtering_button_text",
  upload_data_button_text:                    "upload_data_button_text"
};


// WEBPACK FOOTER //
// ./src/features/topics/components/constants/i18n/ChooseDataSourceModali18nConstants.js